<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="8" class="d-flex align-center">
          <h1>Entregadores para transferir</h1>
        </v-col>
        <v-col cols="12" md="4" class="d-flex align-center mt-1">
          <v-text-field
            label="Entregador"
            v-model="searchText"
            hide-details
            @keydown.enter="searchDeliverer"
            class="mx-4 pa-0"
          ></v-text-field>
          <v-btn @click="searchDeliverer" color="success" large>Buscar</v-btn>
        </v-col>
      </v-row>
      <div class="divider mt-5"></div>
      <div v-if="isDeliverersLoading" class="d-flex align-center justify-center" style="height: 178px">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <div v-else>
        <v-row v-if="filteredDeliverers.length" class="align-center ma-1">
          <v-col cols="12" md="12" class="pt-5">
            <div class="d-flex">
              <v-checkbox
                label="Selecionar todos"
                :input-value="hasAllDeliverersSelected"
                @click="selectAllDeliverers"
                hide-details
              ></v-checkbox>
            </div>
          </v-col>
          <v-col v-for="(deliverer, index) in filteredDeliverers" :key="index" cols="12" md="3" class="pt-2">
            <v-checkbox
              v-model="selectedDeliverers"
              :label="deliverer.name"
              :value="deliverer.id"
              :true-value="selectedDeliverers.includes(deliverer.id)"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col v-if="hasDeliverers" cols="12" class="d-flex justify-end ma-0 pa-0 pt-2">
            <v-btn
              :loading="isTransferButtonLoading"
              :disabled="shouldDisableButton"
              large
              color="success"
              @click="transferDeliverers()"
              class="ml-4"
            >
              Transferir
            </v-btn>
          </v-col>
        </v-row>
        <span v-else class="d-flex justify-center mt-6 mb-2"> Nenhum entregador encontrado </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { TranshipmentTransferHandler } from '@/store/modules/transhipmentTransfer';
export default {
  data: () => ({
    searchText: '',
    deliverers: [],
    filteredDeliverers: [],
    selectedDeliverers: [],
    isDeliverersLoading: false,
    isTransferButtonLoading: false
  }),

  computed: {
    // filteredDeliverers() {
    //   return this.deliverers;
    //   // return this.deliverers.filter((item) => {
    //   //   return item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
    //   // });
    // },

    hasAllDeliverersSelected() {
      const totalDeliverers = this.filteredDeliverers.length;
      const totalSelectedDeliverers = this.selectedDeliverers.length;
      return totalDeliverers !== 0 && totalDeliverers === totalSelectedDeliverers;
    },

    hasDeliverers() {
      return this.deliverers.length;
    },

    deliverersTranshipmentId() {
      return TranshipmentTransferHandler.getSelectedTranshipmentId(this);
    },

    transhipmentToTransferId() {
      return TranshipmentTransferHandler.getSelectedTranshipmentToTransferId(this);
    },

    hasTranshipmentToTransferId() {
      return TranshipmentTransferHandler.getSelectedTranshipmentToTransferId(this) !== null;
    },

    shouldDisableButton() {
      const hasSelected = this.selectedDeliverers.length > 0;

      if (hasSelected && this.hasTranshipmentToTransferId) return false;
      else return true;
    }
  },

  watch: {
    deliverersTranshipmentId: {
      handler() {
        this.fetchDeliverers();
      }
    },
    searchText: {
      handler(searchText) {
        if (searchText === '') {
          this.selectedDeliverers = [];
          this.filteredDeliverers = this.deliverers;
        }
      }
    }
  },

  created() {
    this.fetchDeliverers();
  },

  methods: {
    ...mapActions('TranshipmentStore', ['fetchTranshipmentBetweenDeliverers', 'setTransferDataDeliverers']),
    async fetchDeliverers() {
      try {
        this.isDeliverersLoading = true;
        this.deliverers = [];
        this.selectedDeliverers = [];
        const data = await this.fetchTranshipmentBetweenDeliverers(this.deliverersTranshipmentId);
        this.deliverers = data;
        this.filteredDeliverers = [...this.deliverers];
      } catch (err) {
        console.error(err);
      } finally {
        this.isDeliverersLoading = false;
      }
    },

    async transferDeliverers() {
      try {
        this.isTransferButtonLoading = true;

        const body = {
          transhipmentDestinationId: this.transhipmentToTransferId,
          transhipmentDeliverers: this.selectedDeliverers
        };
        const data = await this.setTransferDataDeliverers(body);
        await this.fetchDeliverers();

        if (data.success) {
          await this.fetchDeliverers();
          this.$emit('feedbackReceived', { errors: ['Entregadores transferidos com sucesso!'], errorsType: 'success' });
          this.fetchDeliverers();
        } else {
          this.$emit('feedbackReceived', { errors: data.errors, errorsType: 'error' });
        }
      } catch (e) {
        console.error(e);
        this.$emit('feedbackReceived', {
          errors: ['Opss, algo deu errado na transferência dos entregadores!'],
          errorsType: 'error'
        });
      } finally {
        await this.fetchDeliverers();
        this.isTransferButtonLoading = false;
      }
    },

    searchDeliverer() {
      this.selectedDeliverers = [];
      this.filteredDeliverers = this.deliverers.filter(({ name: delivererName }) => {
        return delivererName.toLowerCase().includes(this.searchText.toLowerCase());
      });
    },

    selectAllDeliverers() {
      if (this.hasAllDeliverersSelected) {
        this.selectedDeliverers = [];
      } else {
        const deliverersIds = this.filteredDeliverers.map(({ id }) => id);
        this.selectedDeliverers = deliverersIds;
      }
    }
  }
};
</script>

<style></style>
